import { createTheme, type ThemeOptions, type Theme } from '@mui/material';

const baseLayout = {
  drawer: {
    width: 280,
  },
  header: {
    height: 80,
  },
  demoAlert: {
    height: 32,
  },
  content: {
    maxWidth: 1064,
  },
};

export const themeWithBreakpointsIncludingDrawer = (themeOptions: ThemeOptions, theme: Theme) => {
  const drawerWidth = theme?.layout?.drawer.width;
  const values = { ...theme?.breakpoints?.values };

  if (drawerWidth && theme?.breakpoints?.keys) {
    theme.breakpoints.keys.forEach((key) => {
      if (theme?.breakpoints?.values && theme?.breakpoints?.values[key]) {
        values[key] = Number(theme?.breakpoints?.values[key]) + drawerWidth;
      }
    });
  }

  return createTheme(themeOptions, {
    breakpoints: {
      values: {
        xs: values.xs || 0,
        sm: values.sm || 0,
        md: values.md || 0,
        lg: values.lg || 0,
        xl: values.xl || 0,
      },
    },
  });
};

export default baseLayout;
